// extracted by mini-css-extract-plugin
export default {"commentBtn":"AddComments_commentBtn__aLu7D","commentForm":"AddComments_commentForm__A9BI5"};